<s1-input-select [control]="control" [itemsList]="priorita" [label]="'shared.fields.priorita'" [readonly]="readonly"></s1-input-select>